import script from "./EntitlementAttributesTile.vue?vue&type=script&setup=true&lang=js"
export * from "./EntitlementAttributesTile.vue?vue&type=script&setup=true&lang=js"

import "./EntitlementAttributesTile.vue?vue&type=style&index=0&id=08d95e69&scoped=true&lang=css"
script.__scopeId = "data-v-08d95e69"

export default script